<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	//Stores
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';

	export let device;

	let id = real_id(device.id);

	let settings = readDeviceSettings(id);

	let transition = settings[`${get_gen_2_component_channel_structure(device)}`]?.default?.transition;
	let cacheTransition = transition;

	let loading = false;

	const min = 0;
	const max = 5;

	const setDefaultTransition = async () => {
		if (cacheTransition === transition) return;
		loading = true;
		if (transition < min || transition > max) {
			return toast.open({
				type: 'danger',
				title:
					$format('movement_limit_toast', {
						values: { min: min, max: max },
					}) || 'Values must be between min - max!',
			});
		}

		const params = {
			id: device.channel,
			config: {
				default: { transition },
			},
		};

		const res: SettingRequest = await gen2Request(
			device,
			`${get_gen_2_component_from_category(device)}.SetConfig`,
			params,
		);
		const response = onSettingsResponse(res, device);
		if (response) {
			settings[`${get_gen_2_component_channel_structure(device)}`].default.transition = transition;
			devices_settings.update_devices_settings(id, settings);
			cacheTransition = transition;
		} else {
			transition = cacheTransition;
		}
		loading = false;
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('default_transition_description', {
		values: { value: transition, min: min, max: max },
		default: `Transition time (in seconds) when transition is not explicitly set. Value must be between ${min}-${max}.`,
	})}
</Text>
<Input
	class="mb-s"
	size="m"
	bind:value={transition}
	type={'number'}
	{min}
	{max}
	step={1}
	on:enter={setDefaultTransition}
	id="input-0d7t7v3"
	aria-label={$format('default_transition_description', {
		values: { value: transition, min: min, max: max },
		default: `Transition time (in seconds) when transition is not explicitly set. Value must be between ${min}-${max}.`,
	})}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setDefaultTransition}
	>{$format('button_save')}</Button
>
